export default __webpack_public_path__ + "static/media/ventilador-bcs.d2893f02.jpg";